// @ts-nocheck
import ROUTES from "../docRoutes/docRoutes";
import { Navigate } from "react-router-dom";
import { useSessionWatch } from "../hooks/sessionWatch/useSessionWatch";
export const ProtectedRoutesDocs = ({ children, isAccessible }) => {

    const isAuthTokenExist = localStorage.getItem('docGridToken');
    useSessionWatch(Boolean(isAuthTokenExist));
    if (!isAuthTokenExist) {
        return <Navigate to={ROUTES?.LOGIN} replace />
    }
    if (isAccessible || isAccessible === undefined) {
        return children
    }
    return <Navigate to={ROUTES?.BRIEFCASE} replace />
}
